import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PLAN_LABELS } from '@esgdash/shared';
import { useAuth } from '../context/AuthContext';
import { useHealth } from '../hooks/useData';
import { Badge } from './ui';

export function TopBar({ title, breadcrumb, onMenu }: { title: string; breadcrumb?: string; onMenu?: () => void }) {
  const { user, isAuthenticated, logout } = useAuth();
  const { data: health } = useHealth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    setMenuOpen(false);
    navigate('/');
  };

  return (
    <header className="top-bar">
      <div className="top-bar-left">
        <button className="menu-toggle" onClick={onMenu} aria-label="Toggle navigation">
          ☰
        </button>
        <div>
          <div className="page-title">{title}</div>
          {breadcrumb && <div className="breadcrumb">{breadcrumb}</div>}
        </div>
      </div>

      <div className="top-bar-right">
        {health?.demo && <Badge tone="yellow">Demo mode</Badge>}
        {isAuthenticated && user ? (
          <div className="user-menu">
            <button
              className="user-button"
              onClick={() => setMenuOpen((o) => !o)}
              aria-haspopup="menu"
              aria-expanded={menuOpen}
              aria-label="Account menu"
            >
              <span className="avatar">{user.name.charAt(0).toUpperCase()}</span>
              <span className="user-name">{user.name}</span>
              <Badge tone="purple">{PLAN_LABELS[user.plan]}</Badge>
            </button>
            {menuOpen && (
              <div className="user-dropdown" onMouseLeave={() => setMenuOpen(false)}>
                <div className="user-dropdown-email">{user.email}</div>
                <Link to="/account" className="user-dropdown-item" onClick={() => setMenuOpen(false)}>
                  Account & API keys
                </Link>
                <button className="user-dropdown-item" onClick={handleLogout}>
                  Sign out
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className="auth-actions">
            <Link to="/login" className="btn btn-ghost btn-sm">
              Sign in
            </Link>
            <Link to="/register" className="btn btn-primary btn-sm">
              Get started
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
